import { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Collapse,
  Spinner,
} from "reactstrap";
// componentes
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ImportCreate from "./ImportCreate";
import ImportUpdate from "./ImportUpdate";
import ImportDelete from "./ImportDelete";
// service
import { getConfigApp } from "../../../utils/services/configApp";

export default function ModalAllImports(props) {
  const { toggle, isOpen, idEvent, getData, eventName } = props;
  // collapse
  const [collapseCreate, setCollapseCreate] = useState(false);
  const [collapseUpdate, setCollapseUpdate] = useState(false);
  const [collapseDelete, setCollapseDelete] = useState(false);
  // possui app
  const [haveApp, setHaveApp] = useState(false);
  // carregamentop
  const [loading, setLoading] = useState(true);

  function toggleCollapseCreate() {
    setCollapseCreate(!collapseCreate);
    setCollapseUpdate(false);
    setCollapseDelete(false);
  }

  function toggleCollapseUpdate() {
    setCollapseCreate(false);
    setCollapseUpdate(!collapseUpdate);
    setCollapseDelete(false);
  }

  function toggleCollapseDelete() {
    setCollapseCreate(false);
    setCollapseUpdate(false);
    setCollapseDelete(!collapseDelete);
  }

  async function verifyApp() {
    try {
      const res = await getConfigApp(idEvent, "");

      const config = res.data.findAllMobileAppData.data[0];

      if (config.app && config.app.length > 0) {
        setHaveApp(true);
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    verifyApp();
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Importadores de Push</ModalHeader>
        <ModalBody>
          {loading ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Spinner />
            </div>
          ) : haveApp ? (
            <>
              <Row
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 10,
                  width: "245px",
                }}
              >
                <SectionComponent
                  sectionName="Criar Push"
                  setIsOpen={toggleCollapseCreate}
                  isOpen={collapseCreate}
                />
              </Row>

              <Collapse isOpen={collapseCreate}>
                <ImportCreate
                  toggleModal={toggle}
                  idEvent={idEvent}
                  getData={getData}
                  eventName={eventName}
                />
              </Collapse>

              <Row
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 10,
                  width: "245px",
                }}
              >
                <SectionComponent
                  sectionName="Atualizar Push"
                  setIsOpen={toggleCollapseUpdate}
                  isOpen={collapseUpdate}
                />
              </Row>

              <Collapse isOpen={collapseUpdate}>
                <ImportUpdate
                  toggleModal={toggle}
                  idEvent={idEvent}
                  getData={getData}
                />
              </Collapse>

              <Row
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 10,
                  width: "245px",
                }}
              >
                <SectionComponent
                  sectionName="Deletar Push"
                  setIsOpen={toggleCollapseDelete}
                  isOpen={collapseDelete}
                />
              </Row>

              <Collapse isOpen={collapseDelete}>
                <ImportDelete
                  toggleModal={toggle}
                  idEvent={idEvent}
                  getData={getData}
                />
              </Collapse>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                textAlign: "center",
                color: "red",
                fontWeight: "bold",
              }}
            >
              <a>O evento não possui aplicativo</a>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}
